module.exports = __webpack_public_path__ + "static/media/events-cover.946fec34.jpg";